export const getCurrencySymbol = (
  currency: string | undefined,
  locale?: string
) =>
  (0)
    .toLocaleString(locale, {
      style: 'currency',
      currency: currency || 'usd',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim();
